/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Criterion
 */
export interface Criterion {
    /**
     * 
     * @type {string}
     * @memberof Criterion
     */
    criterion: string;
}

/**
 * Check if a given object implements the Criterion interface.
 */
export function instanceOfCriterion(value: object): value is Criterion {
    if (!('criterion' in value) || value['criterion'] === undefined) return false;
    return true;
}

export function CriterionFromJSON(json: any): Criterion {
    return CriterionFromJSONTyped(json, false);
}

export function CriterionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Criterion {
    if (json == null) {
        return json;
    }
    return {
        
        'criterion': json['criterion'],
    };
}

export function CriterionToJSON(value?: Criterion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'criterion': value['criterion'],
    };
}

